import { useQuery } from '@tanstack/react-query';
import { API } from '@/utils/API';

export interface DashboardStudySite {
  id: string;
  site_name: string | null;
  protocol_number: string | null;
  pi_name: string | null;
  display_id: string | null;
  status: string | null;
}

export const useDashboardStudySites = (studyId: string | undefined) => {
  const { data, isLoading } = useQuery<{ resources: DashboardStudySite[] }>({
    queryKey: ['dashboard', 'studies', studyId, 'sites'],
    queryFn: () =>
      API.authenticated
        .fetch(`/dashboard/studies/${studyId}/sites`)
        .then(r => r.json()),
    enabled: !!studyId,
  });

  return { sites: data?.resources ?? [], isLoading };
};
